(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ony-motion-lookbook"] && !Shopify.designMode) return;
  try {
    
if (!window.onyLookbookControls) {
window.onyLookbookControls = true;
document.addEventListener('click', function(event) {
 const button = event.target.closest('.ony-lookbook button[data-dir]');
 if (!button) return;
 const rail = button.closest('section').querySelector('.ony-track');
 const card = rail.querySelector('article');
 if (!card) return;
 const step = card.offsetWidth + 14, end = rail.scrollWidth - rail.clientWidth;
 const next = Number(button.dataset.dir) > 0 ? (rail.scrollLeft >= end-2 ? 0 : rail.scrollLeft+step) : (rail.scrollLeft <= 2 ? end : rail.scrollLeft-step);
 rail.scrollTo({left:next,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
}

  } catch(e) { console.error(e); }
})();
})();
